import {layers, namedFlavor} from '@protomaps/basemaps';

// Still needed for @mapbox/search-js-react geocoding
export const MAPBOX_TOKEN = `${process.env.GATSBY_MAPBOX_TOKEN}`;

const PMTILES_URL = `${process.env.GATSBY_PMTILES_URL}`;

export const MAP_STYLE = {
	version: 8 as const,
	glyphs: 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
	sprite: 'https://protomaps.github.io/basemaps-assets/sprites/v4/light',
	sources: {
		protomaps: {
			type: 'vector' as const,
			url: `pmtiles://${PMTILES_URL}`,
			attribution: '<a href="https://protomaps.com">Protomaps</a> | <a href="https://openstreetmap.org">OpenStreetMap</a>',
		},
	},
	layers: layers('protomaps', namedFlavor('light'), {lang: 'en'}),
};
